import {Injectable} from '@angular/core';
import {CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {CanDeactivateComponent} from './can-deactivate-component.class';
import {ConfirmationService} from 'primeng/api';

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<CanDeactivateComponent> {
  private token = '';

  constructor(private confirmationService: ConfirmationService) {}

  canDeactivate(component: CanDeactivateComponent, currentRoute, currentState, nextState: RouterStateSnapshot): Promise<boolean> {

    this.token = localStorage.getItem('at');

    if (nextState.root.queryParams.skipUnsavedChangesGuard || !this.token) {
      return Promise.resolve(true);
    }

    return new Promise((resolve, reject) => {
      if (!component.canDeactivate()) {
        this.confirmationService.confirm({
          key: 'unsavedChangesDialog',
          acceptLabel: 'Sí',
          rejectLabel: 'No',
          message: '¿Desea abandonar la edición de la solicitud? Los cambios no se guardarán.',
          accept: () => {
              setTimeout(() => {
                resolve(true);
              }, 500);
            },
            reject: () => {
              resolve(false);
            }
          });
        } else {
          resolve(true);
        }
      });
  }
}
